import { render } from "./Tab2.vue?vue&type=template&id=234e0a24&scoped=true&ts=true"
import script from "./Tab2.vue?vue&type=script&lang=ts"
export * from "./Tab2.vue?vue&type=script&lang=ts"

import "./Tab2.vue?vue&type=style&index=0&id=234e0a24&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234e0a24"]])

export default __exports__